export function getGreeting(userName = "User") {
  const hour = new Date().getHours();

  let greeting;
  let quotes = [];

  if (hour >= 5 && hour <= 11) {
    greeting = `Good Morning, ${userName}`;
    quotes = [
      "Start your day by turning data into direction.",
      "Fresh data brings fresh opportunities — let’s explore.",
      "Your insights today will shape tomorrow’s decisions.",
      "Morning is the best time to uncover hidden trends."
    ];
  } else if (hour >= 12 && hour <= 16) {
    greeting = `Good Afternoon, ${userName}`;
    quotes = [
      "Your data still has stories left to tell — let’s dig in.",
      "Turn today’s numbers into actionable insights.",
      "Smart decisions are powered by smart analytics.",
      "Let’s refine your strategy using real data."
    ];
  } else if (hour >= 17 && hour <= 20) {
    greeting = `Good Evening, ${userName}`;
    quotes = [
      "A perfect time to review the day’s insights.",
      "Evenings are great for spotting patterns others missed.",
      "Let’s summarize today’s performance with clarity.",
      "Your data can reveal more before the day ends."
    ];
  } else {
    greeting = `Deep Work Mode, ${userName}`;
    quotes = [
      "The best insights come when the world is quiet.",
      "Late hours reveal the strongest data patterns.",
      "This is when serious analysis happens.",
      "Deep focus leads to powerful data discoveries."
    ];
  }

  const quote = quotes[Math.floor(Math.random() * quotes.length)];
  return { greeting, quote };
}
